import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { forwardRef } from "react";
import { toolkitCx } from "../../../constants/classnames";
import Text from "../Text";
import { renderArrow } from "./Link.shared";
const InternalLink = forwardRef(({ arrow, children, className, hoverable = true, onClick, title, ...linkProps }, ref) => {
    const withArrowCx = cx({
        "items-start gap-1 inline-flex": arrow,
    });
    return (_jsx(Text, { ...linkProps, className: cx(className, toolkitCx.layout.transition.colors, withArrowCx, "group cursor-pointer no-underline"), hoverable: hoverable, onClick: onClick, ref: ref, role: "link", tag: "span", title: title, children: _jsxs(_Fragment, { children: [children, renderArrow(arrow, linkProps.size)] }) }));
});
export default InternalLink;
//# sourceMappingURL=Link.js.map